import { Component, input, computed, effect, inject, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { I18nService } from '../../services/i18n.service';
import { IOTObject } from '../../models/object.model';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { SanitizeInputPipe } from '../../pipes/sanitize-input-pipe';

@Component({
  selector: 'app-validation-input',
  imports: [NgClass, FormsModule, NzIconModule, SanitizeInputPipe],
  templateUrl: './validation-input.html',
  styleUrls: ['./validation-input.scss'],
})
export class ValidationInputComponent {
  siblings = input<IOTObject[]>([]);
  placeholder = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  required = input<boolean>(false);
  label = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  warnNameDuplicate = input<boolean>(false);
  wideInput = input<boolean>(false);
  disabled = input<boolean>(false);
  name = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);

  nameChange = output<string>();
  nameDuplicateChange = output<boolean>();
  nameErrorChange = output<boolean>();

  public i18n = inject(I18nService);

  readonly hasDuplicate = computed(() => {
    const currentName = (this.name() ?? '').trim().toLowerCase();
    if (!currentName) return false;

    const siblings = this.siblings() ?? [];
    return siblings.some((s) => (s.objectName ?? '').trim().toLowerCase() === currentName);
  });

  readonly isNameValid = computed(() => !this.hasDuplicate());

  onInputChange(value: string) {
    this.nameChange.emit(value);

    const currentName = value?.trim().toLowerCase();

    const isDuplicate = (this.siblings() ?? []).some(
      (s) => (s.objectName ?? '').trim().toLowerCase() === currentName
    );

    this.nameDuplicateChange.emit(isDuplicate);
  }

  readonly errorEffect = effect(() => {
    const currentName = this.name() ?? '';
    const hasSlash = currentName.includes('/');
    this.nameErrorChange.emit(hasSlash);
  });
}
